import { useFormik } from 'formik'
import { FC, useMemo } from 'react'
import { GrupoView } from '../../core/_models'
import { addPerfisToGrupo } from '../../core/_requests'
import { grupoPerfisSchema } from './validation/grupoPerfisSchema'
import { useT } from '_metronic/i18n/Metronici18n'
import { showAlert, showError, OptionsHelper, ButtonType } from '_metronic/helpers'
import {
  Button,
  FetchState,
  FormSelect,
  IOption,
  ListLoading,
  LoadingIndicator,
  useModal,
} from 'app/components'

export const GrupoPerfisModal: FC = () => {
  const { fetchStates, closeModal } = useModal()
  const { t } = useT()

  const { data: grupo } = (fetchStates['grupo'] || {}) as FetchState<GrupoView>

  const initialValues = {
    perfis: (grupo?.perfis || []).map((perfil) => ({
      label: perfil.descricao,
      value: perfil.nome,
    })) as IOption<string>[],
  }

  const formik = useFormik({
    initialValues,
    validationSchema: useMemo(() => grupoPerfisSchema(t), [t]),
    onSubmit: async (values, { setSubmitting }) => {
      if (!grupo?.id) return

      setSubmitting(true)
      try {
        await addPerfisToGrupo(grupo.id, {
          perfis: values.perfis.map((perfil) => perfil.value),
        })

        await showAlert({
          title: t('common.success'),
          text: t('alert.update', { name: t('grupo.label'), gender: t('grupo.gender') }),
          icon: 'success',
        })
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <FormSelect
        formik={formik}
        entity='permissao'
        name='perfis'
        fetchOptions={OptionsHelper.getOptionsPerfis}
        className='mb-3'
        isMulti
        isRequired
      />
      <div className='d-flex justify-content-center mt-8'>
        <Button
          type={ButtonType.Reset}
          onClick={closeModal}
          className='btn-secondary me-3'
          disabled={formik.isSubmitting}
        >
          {t('common.cancel')}
        </Button>

        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : t('common.send')}
        </Button>
      </div>
      {formik.isSubmitting && <ListLoading />}
    </form>
  )
}
